<template>
  <div class="edit-agent">
    <div class="content-box" :class="type === 'audit' ? 'auditBox' : ''">
      <iframe class="w-full h-full" :src="url"></iframe>
    </div>

    <!-- <div class="footer" v-if="type === 'edit'">
      <el-button class="normal-button" @click="close">取 消</el-button>
      <el-button class="normal-button" type="primary">保 存</el-button>
    </div> -->
    <div class="footer" v-if="type === 'audit'">
      <el-button class="normal-button" type="danger" plain @click="refuseDialog = true">拒 绝</el-button>
      <el-button class="normal-button" type="primary" @click="checkAgent('pass')">通 过</el-button>
    </div>

    <!-- 拒绝的弹窗 -->
    <el-dialog
      title="拒绝请填写原因"
      :visible.sync="refuseDialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :show-close="false"
      width="30%"
      :before-close="refuseDialogClose"
    >
      <el-input
        type="textarea"
        :rows="6"
        :autosize="{ minRows: 3, maxRows: 6 }"
        show-word-limit
        maxlength="200"
        placeholder="请输入内容"
        v-model="refusalReason"
      >
      </el-input>
      <p class="pt-2 text-yellow-theme text-xs leading-22">
        <i class="el-icon-warning-outline pr-1"></i>
        <span>拒绝后，您可联系代理商重新提交申请</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button class="normal-button" @click="refuseDialogClose">取 消</el-button>
        <el-button class="normal-button" type="primary" @click="checkAgent('refuse')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getFreeLink } from '@/api/wenjuan/publish'
import { getStore } from '@dygc/shared'
import { auditOne } from '@/api/wenjuan/qualityControl'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'EditAgent',
  props: {
    type: {
      type: String,
      default: ''
    },
    answerId: {
      type: String,
      default: ''
    },
    close: Function,
    getData: Function
  },
  data() {
    return {
      refuseDialog: false, // 填写拒绝原因的弹窗
      refusalReason: '', // 拒绝原因
      url: ''
    }
  },
  computed: {},
  methods: {
    refuseDialogClose() {
      this.refuseDialog = false
      this.refusalReason = ''
    },
    async getUrl() {
      const surveyId = GlobalConfig.getSurveyId()
      const params = {
        channelType: '0',
        surveyId
      }
      const {
        data: { data }
      } = await getFreeLink(params)
      this.answerChannelId = data[0].id
      const origin = getSurveyDomain()
      const tenantId = GlobalConfig.getTenantId()
      const token = GlobalConfig.getToken()
      this.url = `${origin}/pc/index.html?surveyId=${surveyId}&answerChannelId=${
        this.answerChannelId
      }&token=${token}&tenantId=${tenantId}&companyid=${GlobalConfig.getCompanyId()}&editType=agent#/force-edit-view/${
        this.answerId
      }`
    },
    checkAgent(type) {
      let data = {
        id: this.answerId,
        pass: type === 'pass',
        answerContent: [],
        preAudit: getStore({ name: 'proxy_is_survey_proxy' }),
        auditDescription: '',
        auditCause: [
          {
            id: 107,
            cause: this.refusalReason
          }
        ]
      }
      auditOne(data)
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          this.refusalReason = ''
          if (type === 'pass') {
            this.$message.success('操作成功，该企业已成为您的代理商')
          } else {
            this.$message.warning('已拒绝')
          }
          // 审批成功后，关闭所有弹窗
          this.refuseDialogClose()
          this.close('', 'auditBox')
          this.getData()
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created() {
    this.getUrl()
  },
  watch: {
    answerId(n) {
      this.getUrl()
    }
  }
}
</script>

<style scoped lang="scss">
.edit-agent {
  @apply h-full flex flex-col justify-between;
  .content-box {
    @apply overflow-y-auto h-full;
  }
  .auditBox {
    height: calc(100% - 64px);
  }
  .footer {
    @apply flex justify-end py-4 pr-6 border-t border-solid border-border-gray;
  }
}
</style>
